import React from 'react'

import CommonStyle from 'common/styles/common.css'

class YbIndicator extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var counter = this.props.counter;

    if (counter) {
      return <span className={CommonStyle.indicator}>{counter < 10 ? counter : '9+'}</span>;
    }

    return <span></span>;
  }
}

module.exports = YbIndicator;
